import { render, staticRenderFns } from "./MemberMailList.vue?vue&type=template&id=21be1da6&"
import script from "./MemberMailList.vue?vue&type=script&lang=js&"
export * from "./MemberMailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports